import apiClient from './apiClient';

export interface Debtor {
  id: number;
  cif: string;
  debtor_type: 'individual' | 'corporate';
  is_entrepreneur?: boolean;
  debtor_profile?: string;
  full_name: string;
  id_type: string;
  id_number: string;
  birth_date?: string;
  birth_place?: string;
  gender?: string;
  marital_status?: string;
  education?: string;
  photo_url?: string;
  mother_maiden_name?: string;
  address?: string;
  village?: string;
  district?: string;
  city?: string;
  province?: string;
  postal_code?: string;
  latitude?: number;
  longitude?: number;
  phone?: string;
  email?: string;
  occupation?: string;
  company_name?: string;
  monthly_income?: number;
  source_of_income?: string;
  spouse_name?: string;
  spouse_id_number?: string;
  emergency_contact_name?: string;
  emergency_contact_phone?: string;
  bank_relationship?: string;
  last_facility?: string;
  last_credit_quality?: string;
  last_arrears?: number;
  relationship_start_date?: string;
  slik_document_url?: string;
  slik_effective_plafon?: number;
  slik_outstanding?: number;
  slik_worst_quality?: string;
  slik_data_month?: string;
  slik_position_date?: string;
  slik_score?: number;
  slik_status?: string;
  slik_last_check?: string;
  relations?: Array<{
    type: string;
    name: string;
    birth_info: string;
    relation: string;
    photo_url: string;
  }>;
  business_documents?: Array<{
    file_url: string;
    title: string;
    notes: string;
  }>;
  document_status: string;
  notes?: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export interface DebtorStats {
  total: number;
  active: number;
  incomplete_docs: number;
  blacklist: number;
}

export interface DebtorFilters {
  status?: string;
  debtor_type?: string;
  document_status?: string;
  search?: string;
}

const debtorApi = {
  getAll: (filters?: DebtorFilters) => {
    let endpoint = '/debtors';
    if (filters) {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value) params.append(key, value);
      });
      const queryString = params.toString();
      if (queryString) endpoint += `?${queryString}`;
    }
    return apiClient.get<Debtor[]>(endpoint);
  },

  getById: (id: number) => {
    return apiClient.get<Debtor>(`/debtors/${id}`);
  },

  create: (data: Partial<Debtor>) => {
    return apiClient.post<Debtor>('/debtors', data);
  },

  update: (id: number, data: Partial<Debtor>) => {
    return apiClient.put<Debtor>(`/debtors/${id}`, data);
  },

  delete: (id: number) => {
    return apiClient.delete(`/debtors/${id}`);
  },

  getStats: () => {
    return apiClient.get<DebtorStats>('/debtors/stats/summary');
  },
};

export default debtorApi;
